import { get } from "@insite/client-framework/Services/ApiService";
import { GetRsswSitemapResultModel } from "@store/Store/Components/RsswSitemap/Handlers/GetRsswSitemap";

const rsswSitemapUrl = "api/v1/rssw/getallcars";

export async function getRsswSitemapList(): Promise<GetRsswSitemapResultModel> {
    try {
        const rsswSiteMap = await get<string>(`${rsswSitemapUrl}`);
        return {
            result: rsswSiteMap,
        };
    } catch (error) {
        return {
            result: "",
        };
    }
}
